import { Sprite, spriteIcons as IconSprite } from "@images/index";

const claySpriteImagePath = () => {
  return Sprite;
};

const iconSpriteImagePath = () => {
  return IconSprite;
};

export { claySpriteImagePath, iconSpriteImagePath };
